import classnames from 'classnames';

export const themes = {
  default: ({ color, hasBorder, hasShadow, isCentered }) => ({
    thRoot: classnames(
      `bg-white flex items-center justify-center p-1 relative rounded-small text-${color}`,
      {
        'border-1 border-current': hasBorder,
        'shadow-sm': hasShadow,
      },
    ),
    thInner: classnames('flex flex-col flex-1 items-center sm:flex-row sm:items-center', {
      'sm:initial-flex': isCentered,
    }),
    thIcon: 'p-2',
    thMessage: 'sm:flex-1 p-2',
    thTitle: 'font-bold font-sans text-base text-current rtl:float-left rtl:mr-1',
    thText: 'font-sans text-base rtl:float-left',
    thTextTheme: 'text-sans-1',
    thSlot: 'max-w-full overflow-hidden p-2',
    thCloseButton: 'p-2 self-start',
    thCloseButtonLabel: 'a11y',
  }),
  stack: ({ color, hasBorder, hasShadow, isCentered }) => ({
    thRoot: classnames(`bg-transparent p-1 relative rounded-small text-${color}`, {
      'border-1 border-current': hasBorder,
      'shadow-sm': hasShadow,
    }),
    thInner: classnames('flex flex-col flex-1 items-center sm:flex-row sm:items-center', {
      'sm:initial-flex': isCentered,
    }),
    thIcon: 'p-2',
    thMessage: 'sm:flex-1 p-2',
    thTitle: 'font-bold font-sans text-basetext-current rtl:float-left rtl:mr-1',
    thText: 'font-sans text-base rtl:float-left',
    thTextTheme: 'text-sans-1',
    thSlot: 'max-w-full overflow-hidden p-2',
    thCloseButton: 'p-2 self-start',
    thCloseButtonLabel: 'a11y',
  }),
  transparent: ({ color, hasBorder, hasShadow, isCentered }) => ({
    thRoot: classnames(
      `flex items-center justify-center p-1 relative rounded-small text-${color}`,
      {
        'border-1 border-current': hasBorder,
        'shadow-sm': hasShadow,
      },
    ),
    thInner: classnames('flex flex-col flex-1 items-center sm:flex-row sm:items-center', {
      'sm:initial-flex': isCentered,
    }),
    thIcon: 'px-8 py-2',
    thMessage: 'sm:flex-1 p-2',
    thTitle: 'font-bold font-sans text-base text-current rtl:float-left rtl:mr-1',
    thText: 'font-sans text-base rtl:float-left',
    thTextTheme: 'text-sans-1',
    thSlot: 'max-w-full overflow-hidden p-2',
    thCloseButton: 'p-2 self-start',
    thCloseButtonLabel: 'a11y',
  }),
  specialAlert: ({ color, hasBorder, hasShadow, isCentered }) => ({
    thRoot: classnames(
      `flex items-center justify-center p-1 relative rounded-small text-${color}`,
      {
        'border-1 border-current': hasBorder,
        'shadow-sm': hasShadow,
      },
    ),
    thInner: classnames('flex flex-col flex-1 items-center sm:flex-row sm:items-center', {
      'sm:initial-flex': isCentered,
    }),
    thIcon: 'px-4 py-2',
    thMessage: 'sm:flex-1 p-2',
    thTitle: 'font-bold font-sans text-base text-current rtl:float-left rtl:mr-1',
    thText: `font-sans text-base rtl:float-left text-${color}`,
    thTextTheme: 'text-sans-6',
    thSlot: 'max-w-full overflow-hidden p-2',
    thCloseButton: 'p-2 self-start',
    thCloseButtonLabel: 'a11y',
  }),
};
